module.exports = __webpack_public_path__ + "static/media/checkScope_1.5286d374.png";